import {AfterContentInit, Component, ContentChild, Input, OnDestroy, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {AccordionGroupComponent} from '../../../../../../../common/components/accordion/accordion.group.component';
import {EditButtonGroupComponent} from '../edit-button-group';


@Component({
    selector: 'tfl-panel-details',
    template: `
        <accordion>
            <accordion-group>

                <accordion-header>
                    <accordion-toggle
                        [title]="caption"
                        [rightBlockTmpl]="detailsEditTmpl">

                        <ng-template #detailsEditTmpl>
                            <ng-content select="tfl-edit-button-group"></ng-content>
                        </ng-template>

                    </accordion-toggle>
                </accordion-header>

                <accordion-content>
                    <ng-content></ng-content>
                </accordion-content>

            </accordion-group>
        </accordion>
    `
})
export class PanelDetailsComponent implements AfterContentInit, OnDestroy {

    @Input() caption: string;

    @ViewChild(AccordionGroupComponent) accordionGroupComponent: AccordionGroupComponent;
    @ContentChild(EditButtonGroupComponent) editBlockComponent: EditButtonGroupComponent;

    private detailsEdit$: Subscription;

    ngAfterContentInit() {
        if (this.editBlockComponent) {
            this.detailsEdit$ = this.editBlockComponent.edit
                .subscribe(() => this.accordionGroupComponent.open());
        }
    }

    ngOnDestroy(): void {
        if (this.detailsEdit$) {
            this.detailsEdit$.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/panel-details/panel-details.component.ts